(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog-post"]) return;
  try {
    
  (() => {
    const article = document.querySelector('.vexelon-article');
    const progress = article?.querySelector('[data-article-progress]');
    const progressBar = article?.querySelector('[data-article-progress-bar]');

    if (!article || !progress || !progressBar) return;

    let frame;

    const updateProgress = () => {
      const articleTop = article.getBoundingClientRect().top + window.scrollY;
      const articleHeight = article.offsetHeight;
      const viewportHeight = window.innerHeight;
      const distance = Math.max(articleHeight - viewportHeight, 1);
      const value = Math.min(Math.max((window.scrollY - articleTop) / distance, 0), 1);

      progressBar.style.transform = `scaleX(${value})`;
      frame = undefined;
    };

    const requestProgressUpdate = () => {
      if (frame === undefined) frame = window.requestAnimationFrame(updateProgress);
    };

    updateProgress();
    window.addEventListener('scroll', requestProgressUpdate, { passive: true });
    window.addEventListener('resize', requestProgressUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vexelon-product-film"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('vexelon-film')){
  customElements.define('vexelon-film',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready)return;
      const button=this.querySelector('.vf__play');
      const template=this.querySelector('template');
      if(!button||!template)return;
      this.dataset.ready='true';
      button.addEventListener('click',()=>{
        if(this.hasAttribute('data-playing'))return;
        const mount=this.querySelector('.vf__player');
        mount.append(template.content.cloneNode(true));
        this.setAttribute('data-playing','');
        const player=mount.querySelector('video,iframe');
        player.focus({preventScroll:true});
        if(player.tagName==='VIDEO'){
          const error=this.querySelector('.vf__error');
          player.addEventListener('error',()=>{error.hidden=false;});
          const play=player.play();
          if(play)play.catch(()=>{error.hidden=false;});
        }
      });
    }
    disconnectedCallback(){const video=this.querySelector('video');if(video)video.pause();}
  });
}

  } catch(e) { console.error(e); }
})();
})();
